import {
  PROCTOR_TYPE_TEXTS,
  useGetProctorStorageObjectFiles,
} from '@exam-center/proctor-management';
import {
  ProctorDocumentFields,
  ProctorEmployeeInformationFields,
  ProctorPersonalInformationFields,
  ProctorTypeField,
} from '@exam-center/proctor-request-management';
import { Divider, Flex, Loading, PaperSection, Text } from '@shared/components';
import { formatDate } from '@shared/utils';

import { useExamCenterProctorDetails } from '../../providers';

export default function ExamCenterProctorDetailsReadonlyFields() {
  const { proctor } = useExamCenterProctorDetails();

  const { isLoading: isAgreementStorageObjectsFilesLoading, result: agreementStorageObjectsFiles } =
    useGetProctorStorageObjectFiles({
      storageObjectKeys: proctor.agreementStorageObjects ?? [],
      proctorId: proctor.id,
    });

  return (
    <PaperSection title='ข้อมูลผู้คุมสอบ'>
      <Flex
        sx={(theme) => ({ flexDirection: 'column', p: theme.spacing(6), gap: theme.spacing(6) })}
      >
        <ProctorTypeField
          fields={{
            proctorType: {
              mode: 'view',
              value: <Text>{PROCTOR_TYPE_TEXTS[proctor.type]}</Text>,
            },
          }}
        />
        <Divider />
        <ProctorPersonalInformationFields
          fields={{
            idNumber: {
              mode: 'view',
              value: proctor.idNumber,
            },
            titleTh: {
              mode: 'view',
              value: proctor.titleTh,
            },
            firstNameTh: {
              mode: 'view',
              value: [proctor.firstNameTh, proctor.middleNameTh].filter(Boolean).join(' '),
            },
            lastNameTh: {
              mode: 'view',
              value: proctor.lastNameTh,
            },
            titleEn: {
              mode: 'view',
              value: proctor.titleEn ?? '',
            },
            firstNameEn: {
              mode: 'view',
              value: [proctor.firstNameEn, proctor.middleNameEn].filter(Boolean).join(' '),
            },
            lastNameEn: {
              mode: 'view',
              value: proctor.lastNameEn ?? '',
            },
            phoneNumber: {
              mode: 'view',
              value: proctor.phoneNumber ?? '-',
            },
            email: {
              mode: 'view',
              value: proctor.email ?? '-',
            },
            address: {
              mode: 'view',
              value: proctor.address ?? '-',
            },
          }}
        />
        <Divider />
        <ProctorEmployeeInformationFields
          fields={{
            startedAt: {
              mode: 'view',
              value: formatDate(proctor.startedAt),
              slotProps: {
                label: 'วันที่เริ่มปฏิบัติหน้าที่',
              },
            },
            code: {
              mode: 'view',
              value: proctor.metadata?.employeeId ?? '-',
              slotProps: {
                label: 'รหัสพนักงาน',
              },
            },
            position: {
              mode: 'view',
              value: proctor.metadata?.position ?? '-',
              slotProps: {
                label: 'ตำแหน่ง',
              },
            },
            department: {
              mode: 'view',
              value: proctor.metadata?.department ?? '-',
              slotProps: {
                label: 'ฝ่ายงาน/ส่วนงาน',
              },
            },
            isTerminationAssign: {
              mode: 'view',
              value: <Text>ไม่มีกำหนด</Text>,
            },
            endedAt: {
              mode: 'view',
              value: proctor.endedAt ? formatDate(proctor.endedAt) : '-',
              slotProps: {
                label: 'วันที่สิ้นสุดปฏิบัติหน้าที่',
              },
            },
          }}
          options={{
            shouldShowEndedAtDateDisplay: !!proctor.endedAt,
          }}
        />
        <Divider />
        {isAgreementStorageObjectsFilesLoading ? (
          <Loading sx={{ height: '120px' }} />
        ) : (
          <ProctorDocumentFields
            hideIdentificationFiles
            fields={{
              agreementForms: {
                mode: 'view',
                slotProps: {
                  files: agreementStorageObjectsFiles,
                },
              },
            }}
          />
        )}
      </Flex>
    </PaperSection>
  );
}
